export enum TransactionErrorTypes {
  NONE = 'none',
  FAILED = 'failed',
  AUTHORIZED = 'authorized',
}
